import { render } from "./StaffPage.vue?vue&type=template&id=87ab3256"
import script from "./StaffPage.vue?vue&type=script&lang=js"
export * from "./StaffPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__